import { BaseError } from './base-error';

export class ServerValidationError extends BaseError {}
